import React__default from 'react';
import Column from '../atoms/Column.mjs';
import Divider from './Divider.mjs';

/**
 * Codifies simple button layout patterns
 * - For a single set of buttons, use children
 * - For buttons separated by dividers, use top and bottom props
 */ const ButtonColumn = (props)=>{
    if ('children' in props) {
        return /*#__PURE__*/ React__default.createElement(Column, {
            gap: 2
        }, props.children);
    }
    return /*#__PURE__*/ React__default.createElement(Column, {
        gap: 4
    }, props.top && // This is a bit odd but there are screens where there's nothing directly above the divider
    /*#__PURE__*/ React__default.createElement(ButtonColumn, null, props.top), /*#__PURE__*/ React__default.createElement(Divider, null), /*#__PURE__*/ React__default.createElement(ButtonColumn, null, props.bottom));
};

export { ButtonColumn as default };
//# sourceMappingURL=ButtonColumn.mjs.map
